import { BaseReportPage } from './bases/BaseReportPage';
import { REPORT } from '@consts/reports';
import { FullBodyPercentByMonth } from '@components/reports/products/FullBodyPercentRateByMonth';
import { WarrantyRateByMonth } from '@components/reports/products/WarrantyRateByMonth';
import { SuccessfulCutsByCoverageType } from '@components/reports/products/SuccessfulCutsByCoverageType';
import { SuccessfulCutsByModel } from '@components/reports/products/SuccessfulCutsByModel';
import { GlobalRankByMaterial } from '@components/reports/products/GlobalRankByMaterial';
import { Materials } from '@consts/materials';
import { useReportLoad } from '@hooks/useReportLoad';
import { ReportTips } from '@components/ReportTips';
import { MaterialTypeCutPctByMonth } from '@components/reports/products/MaterialTypeCutPctByMonth';
import { OverallMaterialTypeCutPct } from '@components/reports/products/OverallMaterialTypeCutPct';

interface ProductsProps {
    dateRange: { startDate: string; endDate: string };
    setDateRange: (dateRange: { startDate: string; endDate: string }) => void;
    showTips: boolean;
}

export const Products = ({ showTips, dateRange, setDateRange }: ProductsProps) => {
    const { data: productNames = [] } = useReportLoad({
        reportType: REPORT.PRODUCTS_PRODUCT_NAMES,
        params: {},
    });
    return (
        <BaseReportPage dateRange={dateRange} setDateRange={setDateRange} title={'MO Insights Products'}>
            {showTips && <ReportTips reportType={REPORT.PRODUCTS_TIPS} />}

            <FullBodyPercentByMonth dateRange={dateRange} />

            <WarrantyRateByMonth dateRange={dateRange} />

            <OverallMaterialTypeCutPct />

            <MaterialTypeCutPctByMonth dateRange={dateRange} />

            <SuccessfulCutsByCoverageType dateRange={dateRange} />

            <SuccessfulCutsByModel dateRange={dateRange} />
            {productNames.map(({ productName }: any) => (
                <GlobalRankByMaterial key={productName} dateRange={dateRange} productName={productName} />
            ))}
        </BaseReportPage>
    );
};
